import PropTypes from 'prop-types';

import resolveRelationships from 'core/utils/relationships';
import relationshipsPropTypes, {
  imagePropTypes,
  rubricPropTypes,
} from 'core/utils/prop-types/relationships';
import themePropTypes from 'core/utils/prop-types/theme';
import { topicDateFormat } from 'core/utils/dates';

import withCard from 'core/hocs/withCard';
import Link from 'core/components/Link';
import Image from 'core/components/SmartImage/Amp';


const requiredPayloadImports = ['image', 'rubric'];

const relationships = resolveRelationships(requiredPayloadImports, {}, {
  image: {
    versions: {},
  },
  rubric: {},
});

function Card2(props) {
  const {
    content,
    theme: {
      colors,
    },
    externalLink,
  } = props;

  const {
    attributes: {
      link,
      headline,
      published_at: publishedAt,
      source_url: sourceUrl,
      image,
    },
  } = content;

  const {
    image: {
      versions: relationshipsVersions,
    },
    rubric: {
      title: rubricTitle,
    },
  } = relationships(content);

  const url = externalLink ? sourceUrl : link;

  const contentVersions = image?.attributes?.versions;
  const versions = contentVersions ? contentVersions : relationshipsVersions;

  return (
    <Link to={url} type='secondary'>
      <style jsx>{`
        .content
          display flex
          padding-bottom 20px
        .image
          width 72px
          height 72px
          margin-right 13px
          flex-shrink 0
          position relative
          border-radius 4px
          overflow hidden
          :global(amp-img img)
            object-fit cover
        .headline
          font-size 14px
          font-weight 500
          line-height 1.29
        .text
          display flex
          flex-direction column
          justify-content space-between
          flex-grow 1
        .info
          margin-top 5px
          font-size 12px
          display flex
          justify-content space-between
      `}</style>
      <style jsx>{`
        .content
          border-bottom 1px solid ${colors.placeholder}
        .headline
          color ${colors.primary}
        .time
          color ${colors.hint}
        .rubric
          color ${colors.active1}
      `}
      </style>

      <div className='content'>
        {versions.original && (
          <div className='image'>
            <Image
              versions={versions}
              width={72}
              height={72}
            />
          </div>
        )}
        <div className='text'>
          <div className='headline'>{headline}</div>
          <div className='info'>
            {rubricTitle && <span className='rubric'>{rubricTitle}</span>}
            {publishedAt && (
              <time className='time'>{topicDateFormat(publishedAt)}</time>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}

Card2.propTypes = {
  /**
   * Ссылка для перехода
   */
  externalLink: PropTypes.bool,

  /** @ignore */
  content: relationshipsPropTypes({
    image: imagePropTypes(),
    rubric: rubricPropTypes(),
  }),

  /** @ignore */
  isMobile: PropTypes.bool,

  /** @ignore */
  theme: themePropTypes(`
    {
      fonts: {
        text,
      },
      colors: {
        placeholder,
        primary,
      },
    },
  `),
};

const Card = withCard(Card2);

Card.requiredPayloadImports = requiredPayloadImports;
Card.displayName = 'Card2';

export default Card;
export { Card2 as StorybookComponent };
